import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub, faFigma } from "@fortawesome/free-brands-svg-icons";
import { db, isConfigured } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

function Socials() {
  const [socials, setSocials] = useState([]);
  const [animatedItems, setAnimatedItems] = useState([]);
  
  useEffect(() => {
    fetchSocials();
  }, []);

  const fetchSocials = async () => {
    if (!isConfigured) {
      setSocials(getDefaultSocials());
      return;
    }

    try {
      const docRef = doc(db, 'profile', 'main');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const profile = docSnap.data();
        const socialsList = [
          { href: `mailto:${profile.email || 'drusillakhulwael@gmail.com'}`, icon: faEnvelope },
          { href: `tel:${profile.phone || '+254701780172'}`, icon: faPhone },
          { href: profile.linkedin || 'https://www.linkedin.com/in/drusillakhulwael/', icon: faLinkedin },
          { href: profile.github || 'https://github.com/drusykhulwi', icon: faGithub },
          { href: profile.figma || 'https://www.figma.com/@drusykhulwi', icon: faFigma },
        ];
        setSocials(socialsList);
      } else {
        setSocials(getDefaultSocials());
      }
    } catch (error) {
      console.error('Error fetching socials:', error);
      setSocials(getDefaultSocials());
    }
  };

  const getDefaultSocials = () => [
    { href: "mailto:drusillakhulwael@gmail.com", icon: faEnvelope },
    { href: "tel:+254701780172", icon: faPhone },
    { href: "https://www.linkedin.com/in/drusillakhulwael/", icon: faLinkedin },
    { href: "https://github.com/drusykhulwi", icon: faGithub },
    { href: "https://www.figma.com/@drusykhulwi", icon: faFigma },
  ];

  useEffect(() => {
    socials.forEach((_, index) => {
      setTimeout(() => {
        setAnimatedItems(prev => [...prev, index]);
      }, index * 300);
    });
  }, [socials]);

  return (
    <div className="text-white flex items-center justify-center gap-8">
      {socials.map((item, index) => (
        <a 
          key={index}
          href={item.href} 
          target={item.href.startsWith('http') ? '_blank' : undefined}
          rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
          className={`transition-all duration-700 ease-out hover:scale-125 hover:text-[#89CFF0] ${
            animatedItems.includes(index)
              ? 'transform translate-x-0 opacity-100 animate-bounce-settle'
              : 'transform -translate-x-full opacity-0'
          }`}
        >
          <FontAwesomeIcon icon={item.icon} className="text-2xl" />
        </a>
      ))}
    </div>
  );
}

export default Socials;